import { createAction } from 'redux-actions'

const ns = 'settings/'

/*export const getUserActivity = createAction(`${ns}GET_USER_ACTIVITY`)
export const getUserActivitySuccess = createAction(`${ns}GET_USER_ACTIVITY_SUCCESS`)
export const getUserActivityFail = createAction(`${ns}GET_USER_ACTIVITY_FAIL`)*/

/*export const getUserBadges = createAction(`${ns}GET_USER_BADGES`)
export const getUserBadgesSuccess = createAction(`${ns}GET_USER_BADGES_SUCCESS`)
export const getUserBadgesFail = createAction(`${ns}GET_USER_BADGES_FAIL`)*/

export const setDivisionsLoading = createAction(`${ns}SET_DIVISIONS_LOADING`)
export const getCompanyDivisions = createAction(`${ns}GET_COMPANY_DIVISIONS`)
export const getCompanyDivisionsSuccess = createAction(`${ns}GET_COMPANY_DIVISIONS_SUCCESS`)
export const getCompanyDivisionsFail = createAction(`${ns}GET_COMPANY_DIVISIONS_FAIL`)

export const getUserCompanyCountries = createAction(`${ns}GET_USER_COMPANY_COUNTRIES`)
export const getUserCompanyCountriesSuccess = createAction(`${ns}GET_USER_COMPANY_COUNTRIES_SUCCESS`)
export const getUserCompanyCountriesFail = createAction(`${ns}GET_USER_COMPANY_COUNTRIES_FAIL`)

export const updateUser = createAction(`${ns}UPDATE_USER`)
export const updateUserSuccess = createAction(`${ns}UPDATE_USER_SUCCESS`)
export const updateUserFail = createAction(`${ns}UPDATE_USER_FAIL`)

export const deleteUser = createAction(`${ns}DELETE_USER`)

export const changePassword = createAction(`${ns}CHANGE_PASSWORD`)
export const joinCompany = createAction(`${ns}JOIN_COMPANY`)
export const joinCompanyLoading = createAction(`${ns}JOIN_COMPANY_LOADING`)
export const joinCompanySuccess = createAction(`${ns}JOIN_COMPANY_SUCCESS`)
export const setJoinedCompanyId = createAction(`${ns}SET_JOINED_COMPANY_ID`)
export const setUserDivision = createAction(`${ns}SET_USER_DIVISION`)
export const setUserCountry = createAction(`${ns}SET_USER_COUNTRY`)

// New combined action for updating both division and country
export const updateUserCompanyProfile = createAction(`${ns}UPDATE_USER_COMPANY_PROFILE`)
export const updateUserCompanyProfileLoading = createAction(`${ns}UPDATE_USER_COMPANY_PROFILE_LOADING`)
export const updateUserCompanyProfileSuccess = createAction(`${ns}UPDATE_USER_COMPANY_PROFILE_SUCCESS`)
export const updateUserCompanyProfileFail = createAction(`${ns}UPDATE_USER_COMPANY_PROFILE_FAIL`)

export const leaveCompany = createAction(`${ns}LEAVE_COMPANY`)
export const deleteUserOwnedCompany = createAction(`${ns}DELETE_USER_OWNED_COMPANY`)

export const togglePublicStatus = createAction(`${ns}TOGGLE_PUBLIC_STATUS`)
